import * as React from 'react';
import { RefreshCw } from 'lucide-react';
import { ICON_PX } from '../../../ui';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
  Tooltip, TooltipTrigger, TooltipContent,
} from '../../../ui';

const DOMAINS = [
  { value: 'staffing', label: 'Staffing' },
  { value: 'quality',  label: 'Quality' },
  { value: 'access',   label: 'Access' },
  { value: 'finance',  label: 'Finance' },
  { value: 'consumer', label: 'Consumer' },
  { value: 'health',   label: 'Pop Health' },
];

function ReclassifyDropdown({ currentDomain, onReclassify }) {
  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              className="flex items-center p-1 rounded hover:bg-surface-warm transition-colors text-text-muted hover:text-text-dark"
            >
              <RefreshCw size={ICON_PX.md} />
            </button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent side="bottom">Reclassify domain</TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end" sideOffset={4}>
        <DropdownMenuLabel>Reclassify to…</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {DOMAINS.filter((d) => d.value !== currentDomain).map((d) => (
          <DropdownMenuItem key={d.value} onClick={() => onReclassify(d.value)}>
            {d.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { ReclassifyDropdown };
